import useToaster from "./useToaster";

export default function useTodayBefore() {
  const { addToaster } = useToaster();
  const baseUrl = process.env.REACT_APP_API_URL || "";
  const url = `${baseUrl}/api/today-before`;

  const safeFetch = async (path, options = {}) => {
    try {
      const token = localStorage.getItem("x-token");
      const headers = { Authorization: `Bearer ${token}` };
      if (!(options.body instanceof FormData))
        headers["Content-Type"] = "application/json";
      if (options.headers) Object.assign(headers, options.headers);

      const r = await fetch(`${url}${path}`, { ...options, headers });
      if (r.status === 401) localStorage.removeItem("x-token");
      return await r.json();
    } catch (e) {
      addToaster({ message: e.message, severity: "error" });
      throw e;
    }
  };

  return {
    listItems: () => safeFetch(`/items`),
    refresh: () => safeFetch(`/refresh`, { method: "POST" }),
    generate: (id) =>
      safeFetch(`/generate`, {
        method: "POST",
        body: JSON.stringify({ id }),
      }),
  };
}
